import { useEffect } from 'react'
import { Link, useNavigate, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Container, Row, Form, Spinner } from 'react-bootstrap'
import { API_PATHS, PATHS } from 'config/routes'
import phoneIcon from 'assets/images/login-call.svg'
import loginStep1 from 'assets/images/login-step1.svg'
import { useAtom } from 'jotai'
import { mobilePageTitleAtom } from 'config/store'
import { useRequestOTP } from 'dataLayer/user'
import { useDispatch } from 'react-redux'
import { setPhoneLoginMobile, showSnackbar } from 'store/actions'
import axios from 'axios'
import i18n from 'i18n'

function LoginOTPMobile({ title }) {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const { phone, setPhone } = useOutletContext()

	const { mutate, isLoading } = useRequestOTP(() => {
		axios.get(API_PATHS.getUser).then(res => {
			const laguageUser = res?.data.data.language
			if (laguageUser) {
				i18n.changeLanguage(laguageUser)
			} else {
				i18n.changeLanguage('la')
			}
		})
		navigate(PATHS.OTP_MOBILE)
	})

	function handleRequestOTP() {
		if (!phone) {
			dispatch(showSnackbar(true, t('modal.login.otp_error'), 'error'))
		} else {
			dispatch(setPhoneLoginMobile(phone))
			mutate({ msisdn: phone })
		}
	}

	const [, setMobilePageTitle] = useAtom(mobilePageTitleAtom)
	useEffect(() => {
		setMobilePageTitle(title)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	function handlePhoneInput(e) {
		setPhone(e.target.value)
	}

	return (
		<Container className="login-mobile login-otp" fluid>
			<Row>
				<img
					src={loginStep1}
					alt="Login step 1"
					className="login-step mx-auto mb-3"
				/>
				<p>{t('modal.login.desc')}</p>
			</Row>
			<Row>
				<Form>
					<Form.Group className="mb-3 login-mobile-input">
						<img src={phoneIcon} alt="" />
						<Form.Control
							type="phone"
							value={phone}
							onChange={handlePhoneInput}
							placeholder={t('modal.form.phone')}
						/>
					</Form.Group>
				</Form>
			</Row>
			<Link to={PATHS.OTP_MOBILE}>
				<Button
					variant="secondary"
					disabled={isLoading}
					onClick={handleRequestOTP}
				>
					{t('modal.login.login_otp_btn')}
					{isLoading ? (
						<Spinner animation="border" role="status"></Spinner>
					) : null}
				</Button>
			</Link>
			<Link to={PATHS.LOGIN_PASS_MOBILE}>
				<Button variant="dark">{t('modal.login.login_pass')}</Button>
			</Link>
		</Container>
	)
}

export default LoginOTPMobile
